import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Results } from 'src/app/shared/classes/app.models';
import { ExclusiveService } from 'src/app/shared/services/exclusive.service';


@Component({
  selector: 'molla-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
    @ViewChild('demoRequest') demoRequest: ElementRef;
    public banners = [];
    public videoBanners = [];
    public creativeImages: Array<Results>;
    public editorialImages: Array<Results>;
    public videos: Array<Results>;
    public newArrivalsProducts: Array<Results>;
    public config: any;

    public slides = [];

  constructor(public excluisveAppService: ExclusiveService,
            public router: Router,
            public route: ActivatedRoute
   ) { 
    
}

 ngOnInit() {
        // this.getConfig();
        this.getSlides();
        this.getBanners();
        // this.searchService.setSearch( '');
        // this.searchService.setCategory(1);
        // this.getProducts("creative images");
    }

    ngAfterViewInit() {
        this.route.queryParams.subscribe(params => {
            if (params.view === 'demoRequest') {
                setTimeout(() => {
                    this.demoRequest?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 300);
            }
        });
    }

    public getBanners() {
        this.excluisveAppService.getBanners('premium').subscribe(data => {
            this.banners = data;
        });
    }

    // public getConfig() {
    //     this.appService.getConfig().subscribe(data => {
    //         this.config = data;
    //         this.getProducts('creative images');
    //     });
    // }

    // public getBrands() {
    //     this.brands = this.appService.getBrands();
    // }

    public getSlides() {
        this.excluisveAppService.getSlides('home-premium-slider').subscribe(data => {
            this.slides = data;
        });
    }

}
